import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Deals.css";

function DealsV() {
  const [dealName, setDealName] = useState("");
  const [dealPrice, setDealPrice] = useState("");
  const [selectedSubProducts, setSelectedSubProducts] = useState([]);
  const [menuData, setMenuData] = useState({ products: [], subProducts: [] });
  const [dealImage, setDealImage] = useState(null); // ✅ Image du deal

  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("/api/ProductV/getAllSubProductV");
        setMenuData(res.data);
      } catch (err) {
        console.error("Erreur récupération produits :", err);
      }
    };
    fetchData();
  }, []);

  // Regroupement par catégorie
  const groupByCategory = (items = []) => {
    return items.reduce((acc, item) => {
      const cat = item.category || "AUTRES";
      acc[cat] = acc[cat] || [];
      acc[cat].push(item);
      return acc;
    }, {});
  };

  const grouped = groupByCategory(menuData.subProducts || []);

  const toggleSubProductSelection = (id) => {
    setSelectedSubProducts((prev) =>
      prev.includes(id) ? prev.filter((sp) => sp !== id) : [...prev, id]
    );
  };

  const handleCreateDeal = async () => {
  if (!dealName.trim() || selectedSubProducts.length === 0 || !dealPrice) {
    alert("Veuillez remplir tous les champs du deal.");
    return;
  }

  const formData = new FormData();
  formData.append("name", dealName);
  formData.append("category", "SET");
  formData.append("price", parseFloat(dealPrice));
  formData.append("subProductsV", JSON.stringify(selectedSubProducts)); // 🔹 stringify tableau
  if (dealImage) {
    formData.append("image", dealImage);
  }

  try {
    const res = await axios.post("/api/ProductV/AddProductV", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    alert("✅ Menu Deal créé avec succès !");
    setDealName("");
    setDealPrice("");
    setSelectedSubProducts([]);
    setDealImage(null);
  } catch (error) {
    console.error("❌ Erreur lors de la création du menu deal :", error.response?.data || error.message);
    alert("Erreur lors de la création du menu deal.");
  }
};

  return (
    <div className="deals-container">
      <h2>Création Menu Deal</h2>
      <input
        type="text"
        value={dealName}
        onChange={(e) => setDealName(e.target.value)}
        placeholder="Nom du menu deal"
      />
      <input
        type="number"
        value={dealPrice}
        onChange={(e) => setDealPrice(e.target.value)}
        placeholder="Prix du menu deal"
      />
     <input
      type="file"
      accept="image/*"
      onChange={(e) => setDealImage(e.target.files[0])}
    />

      <div className="subproducts-section">
        {Object.entries(grouped).map(([category, items]) => (
          <div key={category}>
            
            <div className="subproduct-grid">
              {items.map((sp) => (
                <button
                  key={sp._id}
                  className={`subproduct-button ${
                    selectedSubProducts.includes(sp._id) ? "selected" : ""
                  }`}
                  onClick={() => toggleSubProductSelection(sp._id)}
                >
                  {sp.name}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>

      <button className="create-button" onClick={handleCreateDeal}>
        Créer le Deal
      </button>
    </div>
  );
}

export default DealsV;
